module.exports = __webpack_public_path__ + "static/crater-app-collaborate-9a46addb38aadc87c6759a5e2073cb90.jpg";